<template>
  <div class="container page-top not-found">
    <span class="pill">404</span>
    <h1 class="h-title">{{ ui('not_found_title') }}</h1>
    <p class="lead">{{ ui('not_found_body') }}</p>
    <div class="buttons">
      <PillButton to="/">{{ ui('go_home') }}</PillButton>
      <PillButton to="/products" variant="secondary">{{ t('cta2') }}</PillButton>
    </div>
  </div>
</template>

<script setup>
import PillButton from '../components/PillButton.vue'
import { useLocale } from '../composables/useLocale'

const { t, ui } = useLocale()
</script>

<style scoped>
.not-found {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  padding-bottom: var(--section-gap);
  min-height: 60vh;
}

.buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
</style>
